<div class="header-wrapper">
  <div class="head-row left-side">
    <div class="titles-rows">
      <app-dropdown
        [ngModel]="templateId()"
        (ngModelChange)="setTemplate($event)"
        [ngModelOptions]="{ updateOn: 'change' }"
        [disabled]="templateSelectionDisabled$ | async"
        [appTooltip]="
          (hasCommitments$ | async)
            ? 'Template cannot be changed after commitments have been added.'
            : (hasPrimeContract$ | async)
              ? 'Template cannot be changed after prime contract has been added.'
              : ''
        "
        name="template_dropdown"
        class="spend-app-dropdown spend-input-bg mt-0 mb-0"
        optionValue="id"
        optionLabel="name"
        placeholder="Select Template"
        [options]="templates"
        (mouseover)="templateDropdownHovered = true"
        (mouseleave)="templateDropdownHovered = false"
        data-cy="template-dropdown"
      >
        <ng-template #optionContent let-option>
          <div
            class="font-semibold text-sm text-navy-900"
            [ngClass]="{
              'text-red-600': option?.id === DELETE_BUDGET_TEMPLATE.id,
            }"
          >
            {{ option?.name }}
          </div>
        </ng-template>
        <ng-template #selectedContent let-option>
          <div class="flex justify-between w-full">
            <span class="font-semibold text-sm text-navy-900 selected min-w-0">
              @if (areTemplatesLoading$ | async) {
                Loading... <span class="icon-refresh animate-spin"></span>
              } @else if (templateId() === DEFAULT_TEMPLATE_ID) {
                {{ DEFAULT_TEMPLATE_NAME }}
              } @else {
                {{ option?.name }}
              }
            </span>
            <span
              appTooltip="Icon indicates the original template has been adjusted. New budget lines have been added."
              class="icon-adjusted"
              [ngClass]="{
                'invisible disabled': !(templateAdjusted$ | async),
                'bg-navy-100': templateDropdownHovered || (templateSelectionDisabled$ | async),
              }"
            >
            </span>
          </div>
        </ng-template>
      </app-dropdown>
    </div>
    <div class="budget-dollars">Dollars</div>
  </div>
  <div class="head-row right-side">
    <div class="distribution-levers">Cashflow Distribution Levers</div>

    <app-dropdown
      (ngModelChange)="setSelectedYear($event)"
      [ngModel]="selectedYear$ | async"
      [options]="possibleYearsOptions"
      class="spend-app-dropdown pl-4 mt-0 mb-0"
      name="year-column fiscal_year_dropdown"
      optionValue="value"
      optionLabel="key"
    >
      <ng-template #selectedContent let-option>
        <div class="font-semibold text-sm text-navy-900 dropdown-item">
          <span> FY{{ option?.key }} </span>
        </div>
      </ng-template>
      <ng-template #optionContent let-option>
        <div class="dropdown-item selected" [ngClass]="option?.value === ADD_YEAR ? 'text-blue-700' : 'text-navy-900'">
          {{ option?.key }}
        </div>
      </ng-template>
    </app-dropdown>

    <app-dropdown
      (ngModelChange)="setBudgetType($event)"
      [disabled]="viewSelectionDisabled$ | async"
      [ngModel]="selectedSpendType$ | async"
      name="budget_dropdown"
      class="spend-app-dropdown w-60 ml-4 mt-0 mb-0"
      [options]="spendViews$ | async"
      [optionLabel]="null"
      [optionValue]="null"
    >
      <ng-template #selectedContent #optionContent let-option>
        <div class="font-semibold text-sm text-navy-900 w-full">{{ option }}</div>
      </ng-template>
    </app-dropdown>

    <div (click)="exportBudget()" class="max-h-[30px]" appTooltip="Export Budget" tooltipPosition="bottom">
      <span class="icon-download-template text-[22px] text-blue-700 cursor-pointer hover:brightness-[117%]"></span>
    </div>
    <div>
      <app-upload-window
        (chosenFiles)="importBudget($event)"
        iconClass="icon-folded-file-upload text-[22px] cursor-pointer hover:brightness-[117%]"
        acceptFileTypes=".xlsx"
        tooltipText="Import Budget"
      ></app-upload-window>
    </div>

    <!--    <app-simple-button size="large" buttonStyle="color_secondary_border">-->
    <!--      Export Spreadsheet-->
    <!--    </app-simple-button>-->
  </div>
</div>
